import {useState,useEffect} from  'react';
import {Chart as ChartJS,ArcElement,Tooltip,Legend} from 'chart.js'
import zoom from '../../assets/icons/zoom.svg';
import {Pie} from 'react-chartjs-2';
import { durationFilterSelect} from '../../utils/configs';
import { Loading } from '../../common';
import DownloadVector from '../../assets/icons/svg/download-vector.svg';
import VerticalDivider from '../../assets/icons/svg/vertical-divider.svg';
import {downloadFileDashboard} from '../../utils/commonFunctions';
import { CiCalendarDate } from "react-icons/ci";

// import { useTranslation } from 'react-i18next';
import { APIEndpoint } from '../../utils/axios';


ChartJS.register(
    ArcElement,Tooltip,Legend
);

export const PieChart = ({chartLabel,data,options,filtersPie, customDateLabel,isLoading,setLoadingWidgets, setCustomDateLabel,setFilteredWidgetData,filtersChartZoom,setFiltersChartZoom,handleZoom,chartZoom, setShowDateModal,setWidgetRangeId}) => {

	// const { t } = useTranslation();
	const [filters,setFilters]=useState("")
	const [responseChart,setResponseChart]=useState({});
  const [chartHeight, setChartHeight] = useState(230);
	const currentFilter = !chartZoom ? filters : filtersChartZoom;
	const isBetweenDates = currentFilter === "betweenDates";

  useEffect(() => {
    if (chartZoom) {
      setChartHeight(400);
    } else {
      setChartHeight(230);
    }
  }, [chartZoom]);

    useEffect( () => {
        setFilters(filtersPie?.sortBy)
       }, [filtersPie]);

	   const setView=()=>{
		if(filters){
		  setFiltersChartZoom(filters)
		  handleZoom(chartLabel,data,options)
		}
	  }
	  const onBtExport=()=>{
		downloadFileDashboard(data,responseChart)
		}

	const changeFilter = async (e) => {
  e.preventDefault();

  const value = e.target.value;
  const wId = data.widgetId;

	if(value !== 'betweenDates'){
	setCustomDateLabel(prev=>({...prev,[wId]:""}))
	}
  if (value === "betweenDates") {
    setShowDateModal(true);
    setWidgetRangeId(wId);
    return;
  }

  setFilters(value);
  setFiltersChartZoom(value);
  setLoadingWidgets((_)=>({..._,[wId]:true}));
  if (!chartZoom) {
    try {
      const resp = await APIEndpoint.get(
        `portal/v1/widget/${wId}?sortBy=${value}`
      );
      if (resp.success) {
        setFilteredWidgetData(resp.data);
      }
    } catch (error) {
      console.log(error);
    }finally{
      setLoadingWidgets((_)=>({..._,[wId]:false}));
      }
  } else {
    try {
      const resp = await APIEndpoint.get(
        `portal/v1/widget/${wId}?sortBy=${value}`
      );
      if (resp.success) {
        setResponseChart(resp.data);
      }
    } catch (error) {
      console.log(error);
    }finally{
      setLoadingWidgets((_)=>({..._,[wId]:false}));
      }
  }
};

	return (
	<>
		<div className='width100 flexRow alignItemsCenter'>
			<div className='width100 flexRow alignItemsCenter mt-3 justifyContentSpaceBetween'>
				<div style={{whiteSpace:'nowrap'}} className='mb-2 component-header-space'>{ data.widgetName }</div>
				<div className="cmpHeadingRight flexRow alignItemsCenter justifyContentSpaceEvenly">
        <img className="icon-charts" src={DownloadVector} alt="Download icon" onClick={onBtExport}/>
        <img className="icon-divider-charts" src={VerticalDivider} alt="|" />

			<span className='flexRow justifyContentSpaceBetween'>
			{isBetweenDates && <span
					onClick={() => {
					setShowDateModal(true);
					setWidgetRangeId(data.widgetId);
					}}
					title="Edit date range"
					>
				<CiCalendarDate size={20}  color={'#e8812eff'} style={{cursor:'pointer'}} />
				&nbsp;&nbsp;
				</span> }
				<button className='dashboard-border select-dashboard-border'>
					<select
					className='dashboard-button-report'
                	title ={(isBetweenDates && customDateLabel) ? customDateLabel :""}
					onChange={changeFilter} value={!chartZoom?filters:filtersChartZoom}>
					{durationFilterSelect.map((item, index) => {
						let label = item.label;

						if (item.value === "betweenDates" && customDateLabel) {
						label = customDateLabel;  
						}

						return (
						<option key={index} value={item.value}>
						{label}
						</option>
						);
						})}
					</select>
				</button>
				</span>
                </div>

			</div>
		 </div>
		 <div className="card-content2" style={{ position: "relative" }}>

  { isLoading ? (
    <div className='flexRow justifyContentCenter alignItemsCenter'style={{height: `${chartHeight}px`}}>
      <Loading />
    </div>
  ):
    data?.datasets && !Boolean(Object.keys(responseChart).length) ? (
      (data?.datasets[0]?.data?.length > 0 && data?.datasets[0]?.data?.some(d => d !== 0)) ? (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: `${chartHeight}px`,
      }}>
        <div style={{
          width: `${chartHeight}px`, 
          height: `${chartHeight}px`,  
          maxWidth: '100%',
          position: 'relative',
        }}>
          <Pie
            datasetIdKey={data.widgetId}
            data={{ ...data, labels: data.labels || [] }}
            options={{
              responsive: true,
              maintainAspectRatio: false,   
              animation: false,
              resizeDelay: 200,
              elements: { arc: { borderWidth: 0 } },
              legend: { display: false, position: 'bottom' },
              plugins: { datalabels: { display: false } }
            }}
          />
        </div>
      </div>
      ) : (
        <div className='flexRow justifyContentCenter alignItemsCenter dashboard-message'>
          <p>No data available</p>
        </div>
      )
    ) : (
      (responseChart?.datasets?.length > 0 &&
        responseChart?.datasets[0]?.data?.length > 0 &&
        responseChart?.datasets[0]?.data.some(d => d !== 0)) ? (
                  <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: `${chartHeight}px`,
        }}>
          <div style={{
            width: `${chartHeight}px`,   
            height: `${chartHeight}px`, 
            maxWidth: '100%',
            position: 'relative',
          }}>
            <Pie
              datasetIdKey={data.widgetId}
              data={{ ...data, labels: data.labels || [] }}
              options={{
                responsive: true,
                maintainAspectRatio: false,   
                animation: false,
                resizeDelay: 200,
                elements: { arc: { borderWidth: 0 } },
                legend: { display: false, position: 'bottom' },
                plugins: { datalabels: { display: false } }
              }}
            />
          </div>
        </div>
      ) :(
        <div className='flexRow justifyContentCenter alignItemsCenter dashboard-message'>
          <p>No data available</p>
        </div>
      )
    )
  }

</div>

		<div className="container-fluid sm-scrollbar mt-3">
		{data?.datasets && data?.datasets[0]?.data?.some(d => d !== 0) && (
			<div className=" flexRow  sm-scrollbar">

			{!Boolean(Object.keys(responseChart).length)?data?.labelsData.map((item,index) => {
				return (
				<div className={`${!chartZoom ? 'chart-label-bar-chart col-lg-3' : 'zoom-container'}`} key={index}>
					<ul className={`${index === 0 || 'chart-label-seperator'}`}>
					<li className='dashboard-bullet' style={{color:item.color}} >
					<div className="chart-heading-pie">{item.name}<br></br>{item.value}</div>
					</li>
					</ul>
				</div>
				)
			}): responseChart?.datasets[0]?.data?.some(d => d !== 0) && responseChart?.labelsData.map((item,index) => {
				return (
				<div className={`${!chartZoom ? 'chart-label-bar-chart col-lg-3' : 'zoom-container'}`} key={index}>
					<ul className={`${index === 0 || 'chart-label-seperator'}`}>
					<li className='dashboard-bullet' style={{color:item.color}} >
					<div className="chart-heading-pie">{item.name}<br></br>{item.value}</div>
					</li>
					</ul>
				</div>
				)
			})}
 		 <span className="icon-enlarge">
             {!chartZoom &&<img alt='zoom' src={zoom} onClick={()=>setView()} />}
          </span>

		</div>
	)}
	 </div>


	</>

	);

}